import { render, staticRenderFns } from "./vod-report.vue?vue&type=template&id=47c6ddc4"
import script from "./vod-report.vue?vue&type=script&lang=js"
export * from "./vod-report.vue?vue&type=script&lang=js"
import style0 from "./vod-report.vue?vue&type=style&index=0&id=47c6ddc4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports